/* JK HOME DECOR v22 - Fixed Scroll Particles */
(function() {
  'use strict';

  const JK = {
    init() {
      this.initParticles();
      this.initPopup();
      this.initTrustBadges();
      this.initChatbot();
      console.log('JK v22 Fixed Scroll Particles');
    },

    // ==========================================
    // SECTION-AWARE PARTICLES - SCROLL FIXED
    // ==========================================
    initParticles() {
      // Only show particles on homepage
      const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index' || window.location.pathname.endsWith('/index.html');
      if (!isHomepage) return;
      
      const canvas = document.createElement('canvas');
      canvas.id = 'jk-particles';
      canvas.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 1;
        opacity: 0.9;
      `;
      document.body.prepend(canvas);

      const ctx = canvas.getContext('2d');
      let particles = [];
      let animationId;
      let allowedZones = []; // Document-absolute Y ranges where particles should show

      const resize = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      };
      resize();
      window.addEventListener('resize', () => {
        resize();
        updateAllowedZones();
      });

      // Detect which sections should show particles
      // Store zones as DOCUMENT-ABSOLUTE positions (not viewport-relative)
      const updateAllowedZones = () => {
        allowedZones = [];
        const scrollY = window.scrollY || window.pageYOffset;
        
        // Get all sections on the page
        const sections = document.querySelectorAll('section, .shopify-section, [class*="section"]');
        
        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const style = window.getComputedStyle(section);
          const bgColor = style.backgroundColor;
          const classList = section.className.toLowerCase();
          const textContent = section.textContent || section.innerText || '';
          
          let showParticles = false;
          
          // Check by section type/class
          if (classList.includes('image-banner') || classList.includes('image_banner')) {
            showParticles = true; // Header banner
          } else if (classList.includes('custom-liquid') || classList.includes('custom_liquid')) {
            showParticles = true; // Come Home to Color
          } else if (classList.includes('multirow') || classList.includes('multi-row') || classList.includes('multi_row')) {
            showParticles = true; // Pink multirow sections
          } else if (classList.includes('newsletter') || classList.includes('email') || classList.includes('signup')) {
            showParticles = true; // Email signup section
          } else if (classList.includes('apps')) {
            showParticles = true; // Apps section
          }
          
          // Check for specific text content
          if (textContent.includes('Color makes a home feel alive')) {
            showParticles = true;
          }
          
          // Check by background color - if it's pink-ish, show particles
          if (bgColor) {
            const rgb = bgColor.match(/\d+/g);
            if (rgb && rgb.length >= 3) {
              const r = parseInt(rgb[0]);
              const g = parseInt(rgb[1]);
              const b = parseInt(rgb[2]);
              // Pink detection
              if (r > 200 && g < r && b > 200 && r > b) {
                showParticles = true;
              }
              // FDF2F8 pink (253, 242, 248)
              if (r >= 250 && g >= 235 && g <= 250 && b >= 240 && b <= 255) {
                showParticles = true;
              }
            }
          }
          
          // Explicitly EXCLUDE featured-collection sections
          if (classList.includes('featured-collection') || classList.includes('featured_collection')) {
            showParticles = false;
          }
          
          if (showParticles) {
            // Store as DOCUMENT-ABSOLUTE positions (add scrollY to viewport positions)
            allowedZones.push({
              top: rect.top + scrollY,
              bottom: rect.bottom + scrollY
            });
          }
        });
        
        // Merge overlapping zones
        allowedZones.sort((a, b) => a.top - b.top);
        const merged = [];
        for (const zone of allowedZones) {
          if (merged.length === 0 || merged[merged.length - 1].bottom < zone.top - 50) {
            merged.push({...zone});
          } else {
            merged[merged.length - 1].bottom = Math.max(merged[merged.length - 1].bottom, zone.bottom);
          }
        }
        allowedZones = merged;
      };

      // Check if a viewport Y position is in an allowed zone
      const isInAllowedZone = (viewportY) => {
        // Convert viewport Y to document-absolute Y
        const scrollY = window.scrollY || window.pageYOffset;
        const documentY = viewportY + scrollY;
        
        for (const zone of allowedZones) {
          if (documentY >= zone.top && documentY <= zone.bottom) {
            return true;
          }
        }
        return false;
      };

      // Update zones once on load (zones are document-absolute, so don't need to update on scroll)
      setTimeout(updateAllowedZones, 100);
      setTimeout(updateAllowedZones, 500);
      setTimeout(updateAllowedZones, 1000);
      setTimeout(updateAllowedZones, 2000);
      
      // Only update zones on resize, not scroll
      window.addEventListener('resize', updateAllowedZones);

      class Particle {
        constructor() {
          this.reset();
        }
        reset() {
          this.x = Math.random() * canvas.width;
          this.y = Math.random() * canvas.height;
          this.size = Math.random() * 5 + 1.5;
          this.speedX = (Math.random() - 0.5) * 0.6;
          this.speedY = (Math.random() - 0.5) * 0.6;
          this.opacity = Math.random() * 0.35 + 0.6;
          const rand = Math.random();
          if (rand < 0.25) this.color = 'rgba(233, 30, 140, ';
          else if (rand < 0.45) this.color = 'rgba(255, 107, 179, ';
          else if (rand < 0.60) this.color = 'rgba(255, 60, 150, ';
          else if (rand < 0.75) this.color = 'rgba(255, 150, 200, ';
          else if (rand < 0.85) this.color = 'rgba(76, 175, 80, ';
          else if (rand < 0.92) this.color = 'rgba(139, 195, 74, ';
          else this.color = 'rgba(191, 204, 0, ';
        }
        update() {
          this.x += this.speedX;
          this.y += this.speedY;
          this.x += Math.sin(Date.now() * 0.001 + this.y * 0.01) * 0.25;
          this.y += Math.cos(Date.now() * 0.001 + this.x * 0.01) * 0.15;
          if (this.x < -10) this.x = canvas.width + 10;
          if (this.x > canvas.width + 10) this.x = -10;
          if (this.y < -10) this.y = canvas.height + 10;
          if (this.y > canvas.height + 10) this.y = -10;
        }
        draw() {
          // Check if this viewport position is within an allowed document zone
          const inZone = isInAllowedZone(this.y);
          
          if (!inZone) return;
          
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
          ctx.fillStyle = this.color + this.opacity + ')';
          ctx.fill();
        }
      }

      const particleCount = Math.min(70, Math.max(50, Math.floor((canvas.width * canvas.height) / 20000)));
      for (let i = 0; i < particleCount; i++) particles.push(new Particle());

      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        particles.forEach(p => { p.update(); p.draw(); });
        animationId = requestAnimationFrame(animate);
      };
      animate();

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) cancelAnimationFrame(animationId);
        else animate();
      });
    },

    // ==========================================
    // POPUP
    // ==========================================
    initPopup() {
      if (document.cookie.includes('jk_popup_v22')) return;
      
      const popup = document.createElement('div');
      popup.id = 'jk-pro-popup';
      popup.innerHTML = `
        <style>
          #jk-pro-popup { position: fixed; inset: 0; z-index: 999999; display: flex; align-items: center; justify-content: center; opacity: 0; visibility: hidden; transition: all 0.3s ease; padding: 20px; }
          #jk-pro-popup.open { opacity: 1; visibility: visible; }
          .jk-pro-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.6); backdrop-filter: blur(5px); }
          .jk-pro-modal { position: relative; background: #fff; border-radius: 20px; max-width: 520px; width: 100%; overflow: hidden; box-shadow: 0 25px 50px rgba(0,0,0,0.25); transform: translateY(20px); transition: transform 0.3s ease; }
          #jk-pro-popup.open .jk-pro-modal { transform: translateY(0); }
          .jk-pro-close { position: absolute; top: 16px; right: 16px; width: 44px; height: 44px; background: rgba(255,255,255,0.95) !important; border: none !important; border-radius: 50%; cursor: pointer; font-size: 24px; color: #666; display: flex; align-items: center; justify-content: center; z-index: 10; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
          .jk-pro-header { background: linear-gradient(135deg, #E91E8C 0%, #FF6BB3 100%); padding: 50px 30px; text-align: center; color: white; }
          .jk-pro-logo { width: 110px; height: 110px; margin: 0 auto 20px; border-radius: 50%; overflow: hidden; box-shadow: 0 4px 15px rgba(0,0,0,0.2); background: white; }
          .jk-pro-logo img { width: 100%; height: 100%; object-fit: cover; }
          .jk-pro-headline { font-size: 3.2rem; font-weight: 700; margin: 0 0 12px; }
          .jk-pro-subheadline { font-size: 1.5rem; opacity: 0.95; margin: 0; font-weight: 500; }
          .jk-pro-body { padding: 35px 30px; }
          .jk-pro-benefit { text-align: center; color: #444; font-size: 1.15rem; margin-bottom: 28px; line-height: 1.6; }
          .jk-pro-form { display: flex; flex-direction: column; gap: 14px; }
          .jk-pro-form input { padding: 18px 20px; border: 2px solid #ddd !important; border-radius: 12px; font-size: 1.1rem; }
          .jk-pro-form input:focus { outline: none; border-color: #E91E8C !important; }
          .jk-pro-form button { padding: 20px 24px; background: #E91E8C !important; color: white !important; border: none !important; border-radius: 12px !important; font-size: 1.5rem; font-weight: 700; cursor: pointer; }
          .jk-pro-footer { text-align: center; padding: 0 30px 30px; }
          .jk-pro-skip { background: none !important; border: none !important; color: #888 !important; font-size: 1rem; cursor: pointer; text-decoration: underline; }
          .jk-pro-privacy { font-size: 0.9rem; color: #999; margin-top: 18px; }
        </style>
        <div class="jk-pro-overlay"></div>
        <div class="jk-pro-modal">
          <button class="jk-pro-close">&times;</button>
          <div class="jk-pro-header">
            <div class="jk-pro-logo"><img src="https://cdn.shopify.com/s/files/1/0654/7675/5499/t/2/assets/jk-logo-popup.png" alt="JK"></div>
            <h2 class="jk-pro-headline">Get 10% Off</h2>
            <p class="jk-pro-subheadline">Discount Just For You!</p>
          </div>
          <div class="jk-pro-body">
            <p class="jk-pro-benefit">Join our community for exclusive access to new collections, styling tips, and special offers.</p>
            <form class="jk-pro-form">
              <input type="email" placeholder="Email address" required>
              <button type="submit">Get My 10% Off</button>
            </form>
          </div>
          <div class="jk-pro-footer">
            <button class="jk-pro-skip">No thanks, I'll pay full price</button>
            <p class="jk-pro-privacy">We respect your privacy. Unsubscribe anytime.</p>
          </div>
        </div>
      `;
      document.body.appendChild(popup);

      const closePopup = () => {
        popup.classList.remove('open');
        document.body.style.overflow = '';
        document.cookie = 'jk_popup_v22=1;max-age=604800;path=/';
      };

      setTimeout(() => {
        if (!document.cookie.includes('jk_popup_v22')) {
          popup.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
      }, 5000);

      popup.querySelector('.jk-pro-overlay').addEventListener('click', closePopup);
      popup.querySelector('.jk-pro-close').addEventListener('click', closePopup);
      popup.querySelector('.jk-pro-skip').addEventListener('click', closePopup);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });

      popup.querySelector('.jk-pro-form').addEventListener('submit', (e) => {
        e.preventDefault();
        popup.querySelector('.jk-pro-modal').innerHTML = `
          <button class="jk-pro-close" onclick="this.closest('#jk-pro-popup').classList.remove('open');document.body.style.overflow=''">&times;</button>
          <div style="padding:60px 30px;text-align:center;">
            <div style="width:80px;height:80px;background:#E91E8C;border-radius:50%;margin:0 auto 24px;display:flex;align-items:center;justify-content:center;">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <h3 style="font-size:1.8rem;margin:0 0 12px;color:#1a1a1a;">Welcome to JK Home Decor!</h3>
            <p style="color:#555;margin:0 0 28px;font-size:1.1rem;">Check your inbox for your discount code.</p>
            <button onclick="this.closest('#jk-pro-popup').classList.remove('open');document.body.style.overflow=''" style="background:#E91E8C;color:white;border:none;padding:16px 36px;border-radius:12px;font-weight:600;font-size:1.1rem;cursor:pointer;">Start Shopping</button>
          </div>
        `;
        document.cookie = 'jk_popup_v22=1;max-age=604800;path=/';
      });
    },

    // ==========================================
    // TRUST BADGES ON PRODUCT PAGES
    // ==========================================
    initTrustBadges() {
      const isProductPage = window.location.pathname.includes('/products/');
      if (!isProductPage) return;

      const waitForElement = (selector, callback, maxAttempts = 20) => {
        let attempts = 0;
        const check = () => {
          const el = document.querySelector(selector);
          if (el) {
            callback(el);
          } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(check, 200);
          }
        };
        check();
      };

      waitForElement('.product__info-container, .product-form, .product__info-wrapper', (container) => {
        if (document.querySelector('.jk-trust-badges')) return;

        const badges = document.createElement('div');
        badges.className = 'jk-trust-badges';
        badges.innerHTML = `
          <style>
            .jk-trust-badges {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 12px;
              margin: 24px 0;
              padding: 20px;
              background: linear-gradient(135deg, #FDF2F8 0%, #FCE7F3 100%);
              border-radius: 16px;
              border: 1px solid rgba(233, 30, 140, 0.1);
            }
            .jk-trust-badge {
              display: flex;
              align-items: center;
              gap: 10px;
              padding: 12px;
              background: white;
              border-radius: 12px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.04);
            }
            .jk-trust-badge-icon {
              width: 40px;
              height: 40px;
              background: linear-gradient(135deg, #E91E8C 0%, #FF6BB3 100%);
              border-radius: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            }
            .jk-trust-badge-icon svg {
              width: 22px;
              height: 22px;
              stroke: white;
              fill: none;
              stroke-width: 2;
            }
            .jk-trust-badge-text {
              font-size: 0.85rem;
              line-height: 1.3;
            }
            .jk-trust-badge-title {
              font-weight: 600;
              color: #1a1a1a;
              margin-bottom: 2px;
            }
            .jk-trust-badge-desc {
              color: #666;
              font-size: 0.75rem;
            }
            @media (max-width: 480px) {
              .jk-trust-badges {
                grid-template-columns: 1fr;
              }
            }
          </style>
          <div class="jk-trust-badge">
            <div class="jk-trust-badge-icon">
              <svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
            </div>
            <div class="jk-trust-badge-text">
              <div class="jk-trust-badge-title">Original Art</div>
              <div class="jk-trust-badge-desc">Exclusive designs you won't find anywhere else</div>
            </div>
          </div>
          <div class="jk-trust-badge">
            <div class="jk-trust-badge-icon">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <div class="jk-trust-badge-text">
              <div class="jk-trust-badge-title">Made to Order</div>
              <div class="jk-trust-badge-desc">Crafted just for you, 14-21 days</div>
            </div>
          </div>
          <div class="jk-trust-badge">
            <div class="jk-trust-badge-icon">
              <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
            </div>
            <div class="jk-trust-badge-text">
              <div class="jk-trust-badge-title">14-Day Guarantee</div>
              <div class="jk-trust-badge-desc">Happiness guaranteed or store credit</div>
            </div>
          </div>
          <div class="jk-trust-badge">
            <div class="jk-trust-badge-icon">
              <svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
            </div>
            <div class="jk-trust-badge-text">
              <div class="jk-trust-badge-title">US Printed</div>
              <div class="jk-trust-badge-desc">Premium quality, made in America</div>
            </div>
          </div>
        `;

        const priceEl = container.querySelector('.price, .product__price, [class*="price"]');
        const formEl = container.querySelector('form, .product-form');
        
        if (formEl) {
          formEl.parentNode.insertBefore(badges, formEl.nextSibling);
        } else if (priceEl) {
          priceEl.parentNode.insertBefore(badges, priceEl.nextSibling);
        } else {
          container.appendChild(badges);
        }
      });
    },

    // ==========================================
    // AI CHATBOT
    // ==========================================
    initChatbot() {
      const chatbot = document.createElement('div');
      chatbot.id = 'jk-chatbot';
      chatbot.innerHTML = `
        <style>
          #jk-chatbot {
            position: fixed;
            bottom: 20px;
            right: 20px;
            z-index: 99999;
            font-family: var(--font-body-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
          }
          .jk-chat-button {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: linear-gradient(135deg, #E91E8C 0%, #FF6BB3 100%);
            border: none;
            cursor: pointer;
            box-shadow: 0 4px 20px rgba(233, 30, 140, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.3s, box-shadow 0.3s;
          }
          .jk-chat-button:hover {
            transform: scale(1.1);
            box-shadow: 0 6px 25px rgba(233, 30, 140, 0.5);
          }
          .jk-chat-button svg {
            width: 28px;
            height: 28px;
            fill: white;
          }
          .jk-chat-window {
            position: absolute;
            bottom: 70px;
            right: 0;
            width: 400px;
            max-width: calc(100vw - 40px);
            background: white;
            border-radius: 20px;
            box-shadow: 0 10px 40px rgba(0,0,0,0.15);
            overflow: hidden;
            display: none;
            flex-direction: column;
            max-height: 500px;
          }
          .jk-chat-window.open {
            display: flex;
          }
          .jk-chat-header {
            background: linear-gradient(135deg, #E91E8C 0%, #FF6BB3 100%);
            color: white;
            padding: 20px;
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .jk-chat-avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: white;
            overflow: hidden;
            flex-shrink: 0;
          }
          .jk-chat-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .jk-chat-title {
            flex: 1;
          }
          .jk-chat-title h4 {
            margin: 0;
            font-size: 1.3rem;
            font-family: inherit;
          }
          .jk-chat-title p {
            margin: 4px 0 0;
            font-size: 0.95rem;
            opacity: 0.9;
          }
          .jk-chat-close {
            background: rgba(255,255,255,0.2);
            border: none;
            color: white;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            cursor: pointer;
            font-size: 18px;
          }
          .jk-chat-messages {
            flex: 1;
            overflow-y: auto;
            padding: 20px;
            background: #f8f9fa;
            min-height: 200px;
            max-height: 300px;
          }
          .jk-chat-message {
            margin-bottom: 12px;
            display: flex;
            flex-direction: column;
          }
          .jk-chat-message.bot .jk-msg-content {
            background: white;
            color: #333;
            border-radius: 18px 18px 18px 4px;
            align-self: flex-start;
          }
          .jk-chat-message.user .jk-msg-content {
            background: linear-gradient(135deg, #E91E8C 0%, #FF6BB3 100%);
            color: white;
            border-radius: 18px 18px 4px 18px;
            align-self: flex-end;
          }
          .jk-msg-content {
            padding: 14px 18px;
            max-width: 85%;
            font-size: 1.05rem;
            line-height: 1.5;
            box-shadow: 0 1px 3px rgba(0,0,0,0.08);
          }
          .jk-chat-quick-replies {
            padding: 10px 20px;
            background: #f8f9fa;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
          }
          .jk-quick-reply {
            background: white;
            border: 2px solid #E91E8C;
            color: #E91E8C;
            padding: 10px 16px;
            border-radius: 20px;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          }
          .jk-quick-reply:hover {
            background: #E91E8C;
            color: white;
          }
          .jk-chat-input-area {
            padding: 15px;
            background: white;
            border-top: 1px solid #eee;
            display: flex;
            gap: 10px;
          }
          .jk-chat-input {
            flex: 1;
            border: 2px solid #ddd;
            border-radius: 25px;
            padding: 14px 20px;
            font-size: 1.05rem;
            outline: none;
          }
          .jk-chat-input:focus {
            border-color: #E91E8C;
          }
          .jk-chat-send {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: linear-gradient(135deg, #E91E8C 0%, #FF6BB3 100%);
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .jk-chat-send svg {
            width: 20px;
            height: 20px;
            fill: white;
          }
        </style>
        
        <div class="jk-chat-window">
          <div class="jk-chat-header">
            <div class="jk-chat-avatar"><img src="https://cdn.shopify.com/s/files/1/0654/7675/5499/t/2/assets/jk-logo-popup.png" alt="JK"></div>
            <div class="jk-chat-title">
              <h4>JK Home Decor</h4>
              <p>💬 We typically reply instantly</p>
            </div>
            <button class="jk-chat-close">&times;</button>
          </div>
          <div class="jk-chat-messages">
            <div class="jk-chat-message bot">
              <div class="jk-msg-content">Hi there! 👋 Welcome to JK Home Decor. I'm here to help you find the perfect pieces for your home. How can I assist you today?</div>
            </div>
          </div>
          <div class="jk-chat-quick-replies">
            <button class="jk-quick-reply" data-q="shipping">Shipping Info</button>
            <button class="jk-quick-reply" data-q="returns">Returns</button>
            <button class="jk-quick-reply" data-q="products">Product Questions</button>
            <button class="jk-quick-reply" data-q="contact">Contact Human</button>
          </div>
          <div class="jk-chat-input-area">
            <input type="text" class="jk-chat-input" placeholder="Type your message...">
            <button class="jk-chat-send">
              <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
            </button>
          </div>
        </div>
        
        <button class="jk-chat-button">
          <svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
        </button>
      `;

      document.body.appendChild(chatbot);

      const button = chatbot.querySelector('.jk-chat-button');
      const window_ = chatbot.querySelector('.jk-chat-window');
      const closeBtn = chatbot.querySelector('.jk-chat-close');
      const messagesContainer = chatbot.querySelector('.jk-chat-messages');
      const input = chatbot.querySelector('.jk-chat-input');
      const sendBtn = chatbot.querySelector('.jk-chat-send');
      const quickReplies = chatbot.querySelectorAll('.jk-quick-reply');

      const responses = {
        shipping: "📦 All our products are made-to-order just for you! Please allow 14-21 business days for production and delivery. Once shipped, you'll receive a tracking number via email. We offer FREE shipping on orders over $150! 🚚",
        returns: "↩️ Since all items are print-on-demand, we can't accept returns for change of mind. However, if you receive a damaged or defective item, we stand by our Happiness Guarantee! Contact us within 14 days of delivery for store credit. 💖",
        products: "🎨 All our designs are original artwork from our personal collection - you won't find them anywhere else! Our products are printed on premium materials in the USA. We recommend ordering samples for wallpaper to ensure colors meet your expectations. What product are you interested in?",
        contact: "📞 We'd love to hear from you! You can reach us through our Contact Us page and we typically respond within 24-48 hours. Is there something specific I can help you with first?",
        hello: "Hello! 👋 Welcome to JK Home Decor! We specialize in original art printed on beautiful home products. How can I help you today?",
        hi: "Hi there! 😊 Thanks for visiting JK Home Decor. I'm here to help you find the perfect pieces for your space. What can I assist you with?",
        price: "💰 Our prices vary by product type and size. All prices are shown on each product page. Don't forget - you can get 10% off your first order by signing up for our newsletter! 🎉",
        wallpaper: "🖼️ Our wallpaper features original artwork and comes in various sizes. We highly recommend ordering samples first to check the color and scale. Samples are affordable and help ensure you'll love the final result!",
        pillow: "🛋️ Our pillows come in multiple sizes including square accent pillows, lumbar pillows, and euro shams. Each features our original artwork and uses premium materials. Check out our Bedroom collection!",
        bedding: "🛏️ Our bedding collection includes duvet covers, sheet sets, shams, and throw blankets - all featuring our original designs. Perfect for adding a pop of color to any bedroom!",
        default: "Thanks for your message! 💬 I can help you with shipping info, returns, product questions, or connect you with our team. You can also browse our collections or use the quick reply buttons below. What would you like to know?"
      };

      const addMessage = (text, isUser = false) => {
        const msg = document.createElement('div');
        msg.className = `jk-chat-message ${isUser ? 'user' : 'bot'}`;
        msg.innerHTML = `<div class="jk-msg-content">${text}</div>`;
        messagesContainer.appendChild(msg);
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      };

      const getResponse = (message) => {
        const lower = message.toLowerCase();
        if (lower.includes('ship') || lower.includes('deliver') || lower.includes('how long')) return responses.shipping;
        if (lower.includes('return') || lower.includes('refund') || lower.includes('exchange') || lower.includes('damage')) return responses.returns;
        if (lower.includes('hello') || lower.includes('hey')) return responses.hello;
        if (lower.includes('hi')) return responses.hi;
        if (lower.includes('price') || lower.includes('cost') || lower.includes('how much')) return responses.price;
        if (lower.includes('wallpaper')) return responses.wallpaper;
        if (lower.includes('pillow')) return responses.pillow;
        if (lower.includes('bed') || lower.includes('duvet') || lower.includes('sheet')) return responses.bedding;
        if (lower.includes('contact') || lower.includes('human') || lower.includes('person') || lower.includes('help')) return responses.contact;
        if (lower.includes('product') || lower.includes('quality') || lower.includes('material')) return responses.products;
        return responses.default;
      };

      const sendMessage = () => {
        const text = input.value.trim();
        if (!text) return;
        
        addMessage(text, true);
        input.value = '';
        
        setTimeout(() => {
          addMessage(getResponse(text));
        }, 500);
      };

      button.addEventListener('click', () => {
        window_.classList.toggle('open');
      });

      closeBtn.addEventListener('click', () => {
        window_.classList.remove('open');
      });

      sendBtn.addEventListener('click', sendMessage);
      input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') sendMessage();
      });

      quickReplies.forEach(btn => {
        btn.addEventListener('click', () => {
          const q = btn.dataset.q;
          addMessage(btn.textContent, true);
          setTimeout(() => {
            addMessage(responses[q] || responses.default);
          }, 500);
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => JK.init());
  } else {
    JK.init();
  }
})();
